jQuery(document).ready( ()=> {

    if  ( document.getElementById("contactform") !== null ) {

        const contactForm = document.getElementById("contactform");

        // Inputs focusin

        ca_formInputsFocusIn(contactForm);

        // contactform -> submit button -> Click

        let eventToListen = 'ontouchstart' in window ? 'touchstart' : 'click';

        contactForm.querySelector('#submit_btn').addEventListener( eventToListen, function ( event ) { 

            event.preventDefault();

            let proceed = true;
            let elCounter = 0;
            let errorMsg ='';
            let filter  = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;

                contactForm.querySelectorAll('input[type="text"], textarea').forEach( item => { 

                    if ( item.id == "name" || item.id =="email" || item.id == "message" ) {    
                        
                        elCounter++;
                        let err = false;
                        
                        switch (item.id) {
                            case 'name':
                                err = ( item.value.trim().length === 0 ) ? true : false;
                                errorMsg = 'Namnet är inte ifyllt!';
                                break;

                            case 'email':
                                err = ( !filter.test( item.value ) ) ? true : false;
                                errorMsg = 'E-postadressen är inte ifylld eller är ogiltig!';
                                break;

                            case 'message':
                                err = ( item.value.trim().length === 0 ) ? true : false;
                                errorMsg = 'Meddelandet är inte ifyllt!';
                                break;
                        }

                        if ( err ) {

                            item.parentNode.previousElementSibling.classList.add('error-color'); // label
                            item.classList.add('error-color'); // input
                            item.nextElementSibling.classList.add('error-corner-label'); // corner

                            const errorBox = item.nextElementSibling.nextElementSibling; // error-message
                            errorBox.firstElementChild.innerHTML=errorMsg; 
                            errorBox.style.display="block";

                            proceed = false;                            

                        }                    

                    }

                } ); // end-forEach

                if ( proceed && elCounter == 3 ) { // Everything looks good! proceed... //

                    grecaptcha.ready( ()=> {

                        grecaptcha.execute(wpajax.GRC_SITE_KEY, {action: 'homepage'}) // Obs: SiteKey
                        .then( function(token) {

                            contactForm.querySelector('#g-recaptcha-response').value=token;
                            contactForm.querySelector('.form-img-loading').style.display="block";
                            contactForm.querySelector('.button-text').innerHTML="Skickar...";

                            let data = new FormData(contactForm); // Create an FormData object
                            data.append('action', 'send_contactform'); // admin-ajax.php uses the action to create two hooks: wp_ajax_youraction and wp_ajax_nopriv_youraction. 

                            if ( data.entries ) { // Workaround

                                let newdata = new FormData(); // p[1] is the value of form entry
                                for (let p of data) {

                                    if ( p[1] ) { newdata.append(p[0], p[1]);	}
                                }
                                data = newdata;
                                // https://docs.microsoft.com/en-US/troubleshoot/developer/browsers/development-website/xmlhttprequest-not-correctly-send-formdata

                            }

                            // for (var pair of data.entries()) { console.log(pair[0]+ ', ' + pair[1]); }

                            let feedback = contactForm.querySelector('#div-feedback');
                            let request = new XMLHttpRequest();

                            request.open('POST', wpajax.WP_AJAX_URL, true);

                            request.onload =  function () {

                                let resp = JSON.parse(this.responseText);

                                if ( this.status >= 200 && this.status < 400 ) {  // If successful
                                
                                    if ( resp.status ) {

                                        feedback.innerHTML='';
                                        feedback.innerHTML=resp.message;
                                     
                                        ca_showHide(feedback, 6000, true); // ca_showHide(el, delay, scale?);
                                        ca_resetContactForm();
                                        

                                    } else {

                                        feedback.innerHTML='';
                                        feedback.innerHTML=resp.message;
                                        feedback.style.backgroundColor='#d95c5c';

                                        ca_showHide(feedback, 6000, true ); // ca_showHide(el, delay, scale?);
                                        ca_resetContactForm();
                                        
                                    }                     

                                }

                            };

                            request.onerror = function() {

                                contactForm.querySelector('.form-img-loading').style.display="none";
                                contactForm.querySelector('#g-recaptcha-response').value='';

                                const msg = '<strong>Ett oväntat fel har uppstått!</strong>: Meddelandet kunde inte skickas. Försök igen senare eller kontakta webbansvarig.';
                                
                                feedback.innerHTML='';
                                feedback.innerHTML=msg;
                                feedback.style.backgroundColor='#d95c5c';

                                ca_showHide(feedback, 6000, true ); // ca_showHide(el, delay, scale?);
                                ca_resetContactForm();                        
                            
                            };

                            request.send( data );

                        }); // gRecaptcha=>then
                    }); // Get recaptcha

                } else {

                    let someErrors = contactForm.querySelector('.some-errors');
                    ca_showHide(someErrors, 6000, true ); // ca_showHide(el, delay, scale?);

                } // Proceed

        });

    }

    function ca_resetContactForm() { // Reset form

        const contactForm = document.getElementById("contactform");

        contactForm.querySelectorAll('input[type="text"], input[type="tel"], textarea').forEach( item => { 

            item.value='';
        
        });

        contactForm.querySelector(".form-img-loading" ).style.display="none";
        contactForm.querySelector('.button-text').innerHTML="Skicka";

    }

});